// extracted by mini-css-extract-plugin
export default {"boxShadow":"BoxShadow_boxShadow__X5bQN"};